import { render } from "./AddonFrame.vue?vue&type=template&id=011b0db9&scoped=true"
import script from "./AddonFrame.vue?vue&type=script&lang=js"
export * from "./AddonFrame.vue?vue&type=script&lang=js"

import "./AddonFrame.vue?vue&type=style&index=0&id=011b0db9&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011b0db9"]])

export default __exports__